import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router";
import LoadingAnimation from "./images/loading.gif";
import withTracker from "./withTracker";
import { inject, observer, } from "mobx-react";
import mediaQueries from "./styles/mediaQueries";
import { css } from "emotion";

const PrivateMotor = lazy(() => import("./components/PrivateMotor"));
const ContentsInsurance = lazy(() => import("./components/ContentsInsurance"));
// Home Insurance
const PersonalDetailsStep = lazy(() =>
  import("./components/HomeInsurance/PersonalDetails")
);
const PropertyDetailsStep = lazy(() =>
  import("./components/HomeInsurance/PropertyDetails")
);
const QuoteResultsStep = lazy(() =>
  import("./components/HomeInsurance/QuoteResults")
);
const BranchSelector = lazy(() => import("./components/BranchSelector"));

const Portal = lazy(() => import("./components/Portal"));

const ThanksStep = lazy(() => import("./components/HomeInsurance/Thanks"));

const HOME_ROUTES = {
  personalDetails: "/private-home",
  propertyDetails: "/private-home/property-details",
  quoteResults: "/private-home/quote-results",
  thanks: "/private-home/thanks",
};

const HOME_NEW_ROUTES = {
  personalDetails: "/home-insurance/quote",
  propertyDetails: "/home-insurance/quote/property-details",
  quoteResults: "/home-insurance/quote/quote-results",
  thanks: "/home-insurance/quote/thanks",
};

const marginTop = css({
  marginTop: "35px",
  [mediaQueries.phone]: {
    marginTop: ".5rem",
  },
});

@inject("portalStore")
@observer
class App extends React.Component {
  componentDidMount() {
    // Force user to select a branch if none is set in the portal
    if (this.props.portalStore.isPortal && !this.props.portalStore.isSet) {
      this.props.history.push('/branch-selector');
    }
  }
  
  render() {
    return (
      <Suspense
        fallback={
          <div className="container my-5">
            <div className="row justify-content-center">
              <div className="col-6 col-md-3 text-center">
                <img
                  src={LoadingAnimation}
                  alt="loading"
                  className="img-fluid px-3"
                />
                <p>Just a second...</p>
              </div>
            </div>
          </div>
        }
      >
        <Switch>
          {this.props.portalStore.isPortal && <Route exact path="/" component={withTracker(Portal)} />}
          {this.props.portalStore.isPortal && <Route exact path="/branch-selector" component={withTracker(BranchSelector)} />}
          <Route exact path="/private-motor" component={withTracker(PrivateMotor)} />
          <Route exact path="/contents-packages" component={withTracker(ContentsInsurance)} />
          {/* Newly Added Routes */}
          <Route exact path="/car-insurance/quote" component={withTracker(PrivateMotor)} /> 
          <Route exact path="/home-insurance/contents/quote" component={withTracker(ContentsInsurance)} />
          <Route
            exact
            path={HOME_ROUTES.personalDetails}
            component={withTracker(PersonalDetailsStep)}
          />
          <Route
            exact
            path={HOME_ROUTES.propertyDetails}
            component={withTracker(PropertyDetailsStep)}
          />
          <Route
            exact
            path={HOME_ROUTES.quoteResults}
            component={withTracker(QuoteResultsStep)}
          />
          <Route
            exact
            path={HOME_ROUTES.thanks}
            component={withTracker(ThanksStep)}
          />
          {/* Newly Added Routes */}
          <Route
            exact
            path={HOME_NEW_ROUTES.personalDetails}
            component={withTracker(PersonalDetailsStep)}
          />
          <Route
            exact
            path={HOME_NEW_ROUTES.propertyDetails}
            component={withTracker(PropertyDetailsStep)}
          />
          <Route
            exact
            path={HOME_NEW_ROUTES.quoteResults}
            component={withTracker(QuoteResultsStep)}
          />
          <Route
            exact
            path={HOME_NEW_ROUTES.thanks}
            component={withTracker(ThanksStep)}
          />
        </Switch>
      </Suspense>
    );
  }
}

export default withRouter(App);
export { HOME_ROUTES, };



// WEBPACK FOOTER //
// ./src/routes.js